export const HLockUrl = {
  ACQUIRE: '/hlock',
  RELEASE: '/hlock{?path}',
};
